import React from "react";
import MemberPhoto from "../../images/Member-of-WKM-logo.png";
import MemberCerti from "../../images/wkm-certificate.jpg";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import FadeIn from "../ui/FadeIn";

const WKM = () => (
  <PageLayout>
    <PageHero
      eyebrow="Global Kindness"
      title="Inspiring Towards Greater Kindness"
      subtitle="Kindness Unlimited is honored to be a Member of The World Kindness Movement since 2005."
      light
    />
    <section className="ku-section bg-white">
      <div className="ku-container max-w-4xl">
        <FadeIn>
          <div className="flex justify-center mb-10">
            <img src={MemberPhoto} className="max-w-sm w-full rounded-ku-lg shadow-elevated" alt="World Kindness Movement member" />
          </div>
          <div className="ku-prose">
            <p>
              Inspiring Towards Greater Kindness Kindness Unlimited is honored to be a Member of The World Kindness Movement since 2005. The mission of the World Kindness Movement is to inspire Individuals, Families, Academia, Corporates and Communities towards greater kindness and ultimately to connect nations to create a kinder world.
            </p>
            <p>
              World Kindness INDIA received independent international endorsement as the Peak National Kindness Body by the World Kindness Movement.
            </p>
            <p>
              The World Kindness Movement is the peak global body and international non-government organization with no religious or political affiliation. Its chief objective is to foster goodwill among the broad community – local, national and international – by way of kindness, and in so doing, create greater understanding and co-operation between all people and all nations throughout the world.
            </p>
            <p>
              The idea behind the World Kindness Movement crystallized at a conference in Tokyo in 1997 when the Small Kindness Movement of Japan brought together like-minded kindness movements from around the world.
            </p>
            <p>
              The World Kindness Movement was officially launched in Singapore on November 18, 2000. Today, the World Kindness Movement brings together a worldwide coalition of kindness organizations that study and promote improved individual and collective human behavior.
            </p>
            <p>
              Current members include over 24 nations, with representatives from Australia, Bangladesh, Brazil, Canada, China, France, India, Indonesia, Italy, Japan, Mexico, Nepal, New Zealand, Nigeria, Oman, Pakistan, Romania, Scotland, South Africa, Switzerland, South Korea, Thailand, Uganda, Ukraine, United Arab Emirates, United Kingdom and the USA.
            </p>
            <div className="my-10">
              <img src={MemberCerti} className="w-full rounded-ku-lg shadow-elevated" alt="WKM certificate" />
            </div>
            <p>
              For more information, please visit our website{" "}
              <a href="https://www.theworldkindnessmovement.org/" target="_blank" rel="noopener noreferrer">
                The World Kindness Movement
              </a>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  </PageLayout>
);

export default WKM;
